import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetBrokerageDetailsUseCase extends BaseUseCase {
    constructor(getBrokerageDetailsRep) {
        super();
        this.getBrokerageDetailsRep = getBrokerageDetailsRep;
    }
    async fetchResult(req) {
        return await this.getBrokerageDetailsRep.getBrokerageSegmentData(req);
    }
}
export default GetBrokerageDetailsUseCase;
